export default __webpack_public_path__ + "static/media/eyesofmadness.6af87987.png";